export function initModal(modal, btnModal) {
  if (modal == null) {
    return;
  }

  const close = modal.querySelector('.modal-titre-close');

  btnModal?.addEventListener('click', function () {
    displayModal(modal);
  });

  close.addEventListener('click', function () {
    hideModal(modal);
  });

  // Quand on clic à l'exterieur de la modal
  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      hideModal(modal);
    }
  });
}

export function displayModal(modal) {
  modal.style.display = 'block';
}

export function hideModal(modal) {
  modal.style.display = 'none';
}
